














































import {
  ComponentInternalInstance,
  computed,
  defineComponent,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  ref,
} from '@vue/composition-api';

import { ChevronRightIcon, AddIcon } from 'tdesign-icons-vue';
import { DialogInstance, DialogPlugin } from 'tdesign-vue';
import TeamOrMemberItem from '@/renderer/components/drawer/MemberManage/components/TeamOrMemberItem.vue';
import DataTransferDialog from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/components/dataTransfer.vue';

// 引入工具类
import { TeamMemberItemData } from '@/renderer/scripts/libs/smh-sdk-class/typings';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import smh, { SMH } from '@/renderer/scripts/smh';
import actionHandler from '@/renderer/views/desktop/ManageConsole/UserManagement/innerUser/compositions/actionHandler';
import tips from '@/renderer/scripts/utils/tips';
import ipc from '@/renderer/scripts/utils/ipc';
import user from '@/renderer/scripts/utils/user';
import { USER_ROLE_MAP } from '@/common/reporter/utils';
import { isAdminOrSuperAdmin } from '@/renderer/scripts/utils/UserRole/getters';
import { RoleMap } from '@/renderer/scripts/utils/ConstantConfig';
import { i18n_t } from '@/locales/i18n';
import useFunctionBox from '../../SpacePage/compositions/useFunctionBox';

type TeamUser = TeamMemberItemData & {
  roleId: number;
  name: string;
  teamRoleId: number;
};

export default defineComponent({
  name: 'TeamMemberMange',
  components: {
    TeamOrMemberItem,
    ChevronRightIcon,
    DataTransferDialog,
    AddIcon,
  },
  setup() {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const { userRole } = user.getUserInfo();
    const { memberList, buildTeam, loading, getTeamList, page, hasMore, total } = useFunctionBox();
    const { deleteItem } = actionHandler();
    const showTransferDialog = ref(false);
    const seletedUsers = ref<TeamUser[]>([]);
    const noPersonalSpace = ref<boolean>(false);

    const showMemberInvite = computed(() => {
      // 团队根目录，且是管理员 有成员邀请 按钮
      const { teamPath } = vm.$route.query;
      if (teamPath) {
        const list = (teamPath as string).split('/');
        if (list.length === 1 && isAdminOrSuperAdmin.value) {
          return true;
        }
      }
      return false;
    });

    const methods = {
      // 用于控制是否可编辑权限
      getDisabledValue(row: TeamUser) {
        // 普通用户禁止编辑
        if (userRole === RoleMap.User) {
          return true;
        }
        // 如果是管理员，且编辑普通用户权限（管理员默认有最高权限）
        if (userRole !== RoleMap.User) {
          if (row.role !== USER_ROLE_MAP.User) {
            return true;
          }
        }
        // 如果当前被操作人是团队管理员，则不能被编辑
        if (row.teamRole === 'teamAdmin') {
          return true;
        }
        return false;
      },
      removeUser(item: TeamUser) {
        const { teamId } = vm.$route.query;
        const dialog: DialogInstance = DialogPlugin.confirm({
          theme: 'warning',
          header: i18n_t('确定要把"{slot1}"从该团队中移除吗？', {
            slot1: item.nickname,
          }),
          body: i18n_t('移除后，该用户在团队空间中创建的文件不会被删除'),
          async onConfirm() {
            if (dialog.hide) {
              dialog.hide();
            }
            try {
              await smh.userAPI.deleteTeamMember({
                teamId: Number(teamId),
                userIds: [item.id],
              });
              tips.success(i18n_t('移除成功'));
              getTeamList(true);
            } catch (e) {
              tips.error(e as MsgError);
            }
          },
        });
      },
      deleteUser(item: TeamUser) {
        deleteItem(item as unknown as SMH.UserBaseInfo, {
          transferData: () => {
            showTransferDialog.value = true;
          },
          directDelte: () => {
            getTeamList(true);
          },
        });
      },
      onAuthOperate(type: 'edit' | 'delete', item: TeamUser) {
        seletedUsers.value = [item];
        if (type === 'delete') {
          // 判断是否是根目录, 根目录删除用户， 非根目录移除用户
          if (showMemberInvite.value) {
            methods.deleteUser(item);
          } else {
            methods.removeUser(item);
          }
        }
        if (type === 'edit') {
          methods.editMemberFileRole(item);
        }
      },

      async editMemberFileRole(row: TeamUser) {
        const { teamId } = vm.$route.query;
        const { id, roleId, name, teamRoleId } = row;
        try {
          await smh.userAPI.editTeamMemberFileRole({
            teamId: Number(teamId),
            authorizeTo: [
              {
                roleId, // 授权的角色：操作者 or 上传者等
                userId: id, // 授权用户的 id
                teamRoleId: Number(teamRoleId), // 授权团队的空间 id
                name, // 授权的昵称或团队名称
              },
            ],
          });
          getTeamList();
        } catch (e) {
          tips.error(e as MsgError);
        }
      },

      jumpToMangeCenter() {
        dispatchRouter({
          name: 'teamManagement',
        });
      },

      scroll(options: { e: Event | WheelEvent; scrollTop: number; scrollBottom: number }) {
        if (loading.value || !hasMore) return;
        const { scrollBottom } = options;
        if (scrollBottom <= 20) {
          page.value += 1;
          getTeamList();
        }
      },

      userTransferSucceed() {
        getTeamList(true);
      },
    };

    onMounted(() => {
      ipc.on(ipc.RENDERER_EVENTS_MAP.USER_INFO_CHANGE, methods.userTransferSucceed);
    });
    onUnmounted(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.USER_INFO_CHANGE, methods.userTransferSucceed);
    });

    return {
      total,
      hasMore,
      RoleMap,
      userRole,
      showMemberInvite,
      showTransferDialog,
      noPersonalSpace,
      seletedUsers,
      loading,
      buildTeam,
      ...methods,
      memberList,
    };
  },
});
